import axios from 'axios';
import { CURRENT_HOST } from '../Constants';

export async function logoutSession(): Promise<void> {
    await axios.post(`${CURRENT_HOST}/api/v1/logout`, {}, { withCredentials: true });
}

export async function validateSession(): Promise<boolean> {
    const res = await axios.post(`${CURRENT_HOST}/api/v1/validate_token`, {}, { withCredentials: true });
    return Boolean(res.data?.flag);
}
